import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import { Link } from 'react-router-dom';
import { DymoPrint } from '../../../lib/labels/DYMO.print';
import Boca from '../../../lib/labels/boca';
import Star from '../../../lib/labels/star';
import AlertModal from '../../Common/AlertModal/AlertModal';
import AlertModalBoca from '../../Common/AlertModalBoca/AlertModalBoca';
import AlertModalStar from '../../Common/AlertModalStar/AlertModalStar';
import PrinterOptions from '../../Common/PrinterOptions/PrinterOptions';
import Share from '../../Common/Share/Share';
import TicketDistribution from '../../TicketDistribution/TicketDistribution';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './EventConfirmation.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class EventConfirmation extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isModalOpen: false,
            isModalOpenBoca: false,
            isModalOpenStar: false,
        }
    }

    toggleAlertModal = (e) => {
        e.preventDefault();
        this.setState({
            isModalOpen: !this.state.isModalOpen,
        });
    }

    confirmAlertModal = () => {
        this.setState({
            isModalOpen: false
        }, () => this.printTransactionDymoTickets());
    }

    printTransactionTickets = async () => {
        if(!this.props.patronTicketURL) {
            window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/transactions/${this.props.confirmationNumber}/print`);
        } else {
            window.open(`${this.props.patronTicketURL}`);
        }
    }

    printTransactionDymoTickets = async () => {
        try {
            const getTicketInfoFromTransaction = await getTicketInfo(this.props.confirmationNumber);
            if (!getTicketInfoFromTransaction.data.error) {

                const { tickets, client, customer } = getTicketInfoFromTransaction.data;
                DymoPrint(this.props.currentPrinter, 'ticket', tickets, client, customer);
                
                getTicketInfoFromTransaction.data.flexpasses.map(async(flexpass) => {
                    await DymoPrint(this.props.currentPrinter, 'flexpass', flexpass, client, customer);
                });
            } else {
                this.setMessage(window.general_strings.msg.oops, getTicketInfoFromTransaction.data.error, 'error');
                setTimeout(() => {
                    this.setMessage('', '', '');
                }, 3000);
            } 
        } catch (error) {
            console.log(error);
        }

        async function getTicketInfo(transaction) {
            return await ApiRequest(`/transactions/${transaction}/ticket-info`);
        }
    }

    printTransactionPDFDymoTickets = async () => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/transactions/${this.props.confirmationNumber}/print-dymo`);
    }

    printerSelect = () => {
        return (
            <div className="showtix-form__group">
                <div className="showtix-form__select">
                    {this.props.printers.length > 0 ? 
                        <select className="showtix-input"
                            value={this.props.currentPrinter}
                            onChange={this.props.handlePrinterChange}>
                            <PrinterOptions printers={this.props.printers} />
                        </select> :
                        <h2>{strings.noPrinterAvailable}</h2>
                    }                  
                </div>
            </div>
        )
    }

    toggleAlertModalBoca = (e) => {
        e.preventDefault();
        if (this.props.currentPrinterBoca === '') {
            this.setState({
                isModalOpenBoca: !this.state.isModalOpenBoca,
            });
        } else {
            this.printTransactionBocaTickets();
        }
    }

    confirmAlertModalBoca = () => {
        if(!localStorage.getItem("defaultBocaPrinter")) {
            localStorage.setItem('defaultBocaPrinter', localStorage.getItem("printersBoca")[0]);
            this.setState({
                currentPrinterBoca: localStorage.getItem("printersBoca")[0]
            });
        }
        this.setState({
            isModalOpenBoca: false
        }, () => this.printTransactionBocaTickets());
    }

    printerSelectBoca = () => {
        return (
            <div className="showtix-form__group">
                <div className="showtix-form__select">
                    {this.props.printersBoca.length > 0 ?
                        <select className="showtix-input"
                                value={this.props.currentPrinterBoca}
                                onChange={this.props.handlePrinterChangeBoca}>
                            <option>Select</option>
                            {this.props.printersBoca.map((printer, i) => (
                                <option value={this.props.printersBoca[i].name}>{this.props.printersBoca[i].name}</option>
                            ))}
                        </select> :
                        <h2>{strings.noPrinterAvailable}</h2>
                    }
                </div>
            </div>
        )
    };

    printTransactionBocaTickets = async () => {
        console.log("printTransactionBocaTickets");
        try {
            const getTicketInfoFromTransaction = await getTicketInfo(this.props.confirmationNumber);
            console.log('Get ticket info from transaction: ', getTicketInfoFromTransaction);
            const client = getTicketInfoFromTransaction.data.client;
            const customer = getTicketInfoFromTransaction.data.customer;
            if (!getTicketInfoFromTransaction.data.error) {
                const tickets = getTicketInfoFromTransaction.data.tickets;
                const flexpasses = getTicketInfoFromTransaction.data.flexpasses;
                if(tickets || flexpasses) {
                    let boca = new Boca();
                    if(tickets) {
                        boca.printFGL(this.props.currentPrinterBoca, 'ticket', tickets, client, customer);
                    }
                    if(flexpasses) {
                        boca.printFGL(this.props.currentPrinterBoca, 'flexpass', flexpasses, client, customer);
                    }
                }
            } else {
                this.setMessage(window.general_strings.msg.oops, getTicketInfoFromTransaction.data.error, 'error');
                setTimeout(() => {
                    this.setMessage('', '', '');
                }, 3000);
            }
        } catch (error) {
            console.log(error);
        }

        async function getTicketInfo(transaction) {
            return await ApiRequest(`/transactions/${transaction}/ticket-info`);
        }
    }

    printerSelectStar = () => {
        return (
            <React.Fragment>
                <div className="showtix-form__group">
                    <div className="showtix-form__select">
                        {this.props.printersStar.length > 0 ? (
                                <select className="showtix-input"
                                    value={this.props.currentPrinterStar}
                                    onChange={this.props.handlePrinterChangeStar}
                                >
                                    <option>Select</option>
                                    {this.props.printersStar.map((printer, i) => (
                                        <option value={this.props.printersStar[i].ip_address}>{this.props.printersStar[i].name} ({this.props.printersStar[i].ip_address})</option>
                                    ))}
                                    <option value='http://localhost:8001'>SM-S230i</option>
                                </select>
                            ) : (
                                <select className="showtix-input"
                                    value={this.props.currentPrinterStar}
                                    onChange={this.props.handlePrinterChangeStar}
                                >
                                    <option>Select</option>
                                    <option value='http://localhost:8001'>SM-S230i</option>
                                </select>
                            )
                        }
                    </div>
                </div>
                {this.props.printersStarUSB.length > 0 && (
                    <React.Fragment>
                        USB Printers:
                        <div className="showtix-form__group">
                            <div className="showtix-form__select">
                                {this.props.printersStarUSB.length > 0 && (
                                    <select className="showtix-input"
                                        value={this.props.currentPrinterStar}
                                        onChange={this.props.handlePrinterChangeStar}
                                    >
                                        <option>Select</option>
                                        {this.props.printersStarUSB.map((printer, i) => (
                                            <option value={this.props.printersStarUSB[i].name}>{this.props.printersStarUSB[i].name}</option>
                                        ))}
                                    </select>
                                )}
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        )
    };

    toggleAlertModalStar = (e) => {
        e.preventDefault();
        if (this.props.currentPrinterStar === '') {
            console.log('toggleAlertModalStar');
            this.setState({
                isModalOpenStar: !this.state.isModalOpenStar,
            });
        } else {
            console.log('printTransactionStarTickets');
            this.printTransactionStarTickets();
        }
    }

    confirmAlertModalStar = () => {
        if(!localStorage.getItem("defaultStarPrinter")) {
            localStorage.setItem('defaultStarPrinter', localStorage.getItem("printersStar")[0]);
            this.setState({
                currentPrinterStar: localStorage.getItem("printersStar")[0]
            });
        }
        this.setState({
            isModalOpenStar: false
        }, () => this.printTransactionStarTickets());
    }

    printTransactionStarTickets = async () => {
        try {
            const getTicketInfoFromTransaction = await getTicketInfo(this.props.confirmationNumber);
            console.log('Get ticket info from transaction: ', getTicketInfoFromTransaction);
            const client = getTicketInfoFromTransaction.data.client;
            const customer = getTicketInfoFromTransaction.data.customer;
            if (!getTicketInfoFromTransaction.data.error) {
                const tickets = getTicketInfoFromTransaction.data.tickets;
                const flexpasses = getTicketInfoFromTransaction.data.flexpasses;
                let star = new Star();
                let isStarUSB = !localStorage.getItem('defaultStarPrinter').includes('http');
                console.log('isStarUSB', isStarUSB)
                if(tickets || flexpasses) {
                    if(tickets) {
                        if (isStarUSB) {
                            console.log('isStarUSB')
                            star.printFGLUSB(localStorage.getItem('defaultStarPrinter'), 'ticket', tickets, client, customer);
                        } else {
                            star.printFGL('ticket', tickets, client, customer);
                        }
                    }
                    if(flexpasses) {
                        if (isStarUSB) {
                            star.printFGLUSB(localStorage.getItem('defaultStarPrinter'), 'flexpass', flexpasses, client, customer);
                        } else {
                            star.printFGL('flexpass', flexpasses, client, customer);
                        }
                    }
                }
            } else {
                this.setMessage(window.general_strings.msg.oops, getTicketInfoFromTransaction.data.error, 'error');
                setTimeout(() => {
                    this.setMessage('', '', '');
                }, 3000);
            }
        } catch (error) {
            console.log(error);
        }

        async function getTicketInfo(transaction) {
            return await ApiRequest(`/transactions/${transaction}/ticket-info`);
        }
    };

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    renderConfirmationMessage = () => {
        switch(this.props.shipping) {
            case 'email':
            return (
                <p>{strings.ticketsEmailed}</p>
            )
            break;

            case 'mail':
            return (
                <p>{strings.ticketsMailed}</p>
            )
            break;

            case 'willcall':
            return (
                <p>{strings.ticketsWillCall}</p>
            )
            break;

            default:
            return (
                <p>{strings.ticketsEmailed}</p>
            )
            break;
        }
    }

    renderWatchStream = () => {
        if ((this.props.confirmationEvent.event_type === 'Video On Demand' || this.props.confirmationEvent.event_type === 'Live Stream' || this.props.confirmationEvent.event_type === 'Scheduled Content') && !this.props.user.role) {
            return (
                <Link
                    className="showtix-button showtix-background__primary-1"
                    to='/stream'
                    target="_blank"
                >
                    {strings.watchStream}
                </Link>
            )
        }
    }

    render() {
        let event = {};
        event.details = {};
        event.details.name = this.props.confirmationEvent.name;
        event.details.event_id = this.props.confirmationEvent.id;
        const isNotReservedOrVipatron = () => this.props.lastPaymentMethod !== 'reserved' && this.props.lastPaymentMethod !== 'vipatron';
        return (
            <React.Fragment>
                <AlertModal
                    isModalOpen={this.state.isModalOpen}
                    toggleAlertModal={this.toggleAlertModal}
                    confirmAlertModal={this.confirmAlertModal}
                    modalTitle={strings.modalTitle}
                    modalDescription={this.printerSelect()}
                    disabled={!this.props.printers.length > 0}
                />
                <AlertModalBoca
                    isModalOpenBoca={this.state.isModalOpenBoca}
                    toggleAlertModalBoca={this.toggleAlertModalBoca}
                    confirmAlertModalBoca={this.confirmAlertModalBoca}
                    modalTitle={strings.modalTitle}
                    modalDescription={this.printerSelectBoca()}
                    disabled={!this.props.printersBoca.length > 0}
                />
                <AlertModalStar
                    isModalOpenStar={this.state.isModalOpenStar}
                    toggleAlertModalStar={this.toggleAlertModalStar}
                    confirmAlertModalStar={this.confirmAlertModalStar}
                    modalDescription={this.printerSelectStar()}
                    printersStar={this.props.printersStar}
                />
                <div className="showtix-confirmation">
                    <div className={"showtix-confirmation__content " + (this.props.isConfirmationOpen ? 'is-active' : '')}>
                        <div className="showtix-section">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <h2 className="showtix-h1">{strings.confirmation}</h2>
                                    {isNotReservedOrVipatron() &&
                                        <span className="showtix-badge confirmation position-relative">{strings.ticketNumber} {this.props.confirmationNumber}</span>
                                    }
                                    
                                    <p>{strings.transactionSuccessful}</p>
                                    
                                    {isNotReservedOrVipatron() && 
                                        this.renderConfirmationMessage()
                                    }
                                    <p>{strings.sms}</p>
                                    {this.renderWatchStream()}
                                </div>
                            </div> 
                            <div className="row">
                                <div className="col-12 text-center">
                                    {isNotReservedOrVipatron() &&
                                        <button
                                            className="showtix-button showtix-background__primary-1"
                                            onClick={this.printTransactionTickets}
                                        >
                                            {this.props.user.role ? (
                                                <React.Fragment>
                                                    {strings.downloadTickets}
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    {strings.downloadTicketsPatron}
                                                </React.Fragment>
                                            )}
                                        </button>
                                    }
                                    {(isNotReservedOrVipatron() && this.props.user.role && this.props.printers.length > 0) &&
                                        <button
                                            className="showtix-button showtix-background__primary-3"
                                            onClick={this.props.printers.length > 1 ? this.toggleAlertModal : this.printTransactionDymoTickets}
                                        >
                                            {strings.printTicketsButton}
                                        </button>
                                    }
                                    {(isNotReservedOrVipatron() && this.props.user.role && this.props.printersBoca.length > 0) &&
                                        <button
                                            className="showtix-button showtix-background__primary-3"
                                            onClick={this.props.printersBoca.length >= 1 ? this.toggleAlertModalBoca : this.printTransactionBocaTickets}
                                        >
                                            {strings.printTicketsBocaButton}
                                        </button>
                                    }
                                    {(isNotReservedOrVipatron() && this.props.user.role && this.props.printers.length > 0) &&
                                        <button
                                            className="showtix-button showtix-background__primary-3"
                                            onClick={this.printTransactionPDFDymoTickets}
                                        >
                                            {strings.printPDFDymoButton}
                                        </button>
                                    }
                                    {(isNotReservedOrVipatron() && this.props.user.role) &&
                                        <button
                                            className="showtix-button showtix-background__primary-3"
                                            onClick={this.props.printersStar.length === 0 || this.props.printersStar.length >= 1  ? this.toggleAlertModalStar : this.printTransactionStarTickets}
                                        >
                                            {strings.printTicketsStarButton}
                                        </button>
                                    }
                                    <button 
                                        className="showtix-button showtix-background__primary-3"
                                        onClick={this.props.continueShopping}
                                    >
                                        {strings.continueShopping}
                                    </button>

                                    {this.props.user.role &&
                                        <button 
                                            className="showtix-button showtix-background__grey-3"
                                            onClick={this.props.sellMoreTickets}
                                        >
                                            {strings.sellMore}
                                        </button>
                                    }
                                </div>
                            </div>
                            {this.props.token !== '' && (
                                <TicketDistribution
                                    isFromCheckout={true}
                                    token={this.props.token}
                                    user={this.props.user}
                                />
                            )}
                            {/* <div className="row">
                                <div className="col-12 text-center">
                                    <a 
                                        className="showtix-button showtix-background__primary-3"
                                        href={`/ticket-distribution?token=${this.props.token}`}
                                    >
                                        Dsitribute tickets
                                    </a>
                                </div>
                            </div> */}
                            
                            <div className="row">
                                <div className="col-12">
                                    <Share
                                        isInline={true}
                                        event={event}
                                        content={`So excited to see ${event.details.name}! You can buy your tickets here: ${process.env.REACT_APP_SITE_URL}/event-details/${event.details.event_id}`}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
         )
    }
}

EventConfirmation.propTypes = {
    isConfirmationOpen: PropTypes.bool,
    confirmationNumber: PropTypes.string,
    continueShopping: PropTypes.func,
    sellMoreTickets: PropTypes.func,
    confirmationEvent: PropTypes.object,
}
 
export default EventConfirmation;


// WEBPACK FOOTER //
// ./src/components/EventListing/EventConfirmation/EventConfirmation.js